import { table } from './_table';
import cloneDeep from 'lodash-es/cloneDeep';
import { replaceNotNumber } from '@shared/helpers/replace';

export const recipients_range = {
  namespaced: true,
  modules: {
    include: table,
    exclude: cloneDeep(table),
    numbers: {
      namespaced: true,
      state: {
        value: []
      },

      getters: {
        value: (state) => {
          return state['value'].map((i) => replaceNotNumber(i));
        }
      },

      mutations: {
        value: (state, value) => (state['value'] = value)
      }
    }
  }
};
